import { Email } from '@air/next-icons';

import { LibraryDetailsAccessibility } from './LibraryDetailsAccessibility';

export const LibraryDetailsAccessibilityPrivate = () => {
  return (
    <LibraryDetailsAccessibility
      description="An admin must approve a member’s request to join this library"
      label="Request to join"
      icon={<Email className="size-4 fill-grey-10" />}
    />
  );
};
